import Swiper, { Navigation, Lazy } from 'swiper';

import '../../../node_modules/swiper/swiper.min.css';
import '../../../node_modules/swiper/modules/navigation/navigation.min.css';
import '../../../node_modules/swiper/modules/lazy/lazy.min.css';

{
    Swiper.use([Navigation, Lazy]);

    const featuredGridCarousels = document.querySelectorAll('.featured-grid-carousel')
    const swiperCarousels = []

    const initSwiper = (el) => {
        const swiper = new Swiper(el, {
            slidesPerView: 1,
            loop: true,
            preloadImages: false,
            watchSlidesProgress: true,
            lazy: {
                checkInView: true,
                loadPrevNext: true,
                loadOnTransitionStart: true
            },
            keyboard: {
                enabled: true
            },
            navigation: {
                nextEl: '.carousel-next',
                prevEl: '.carousel-prev'
            }
        })

        swiperCarousels.push(swiper)
    }

    window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
            swiperCarousels.forEach((carousel, index) => {
                if (!carousel.destroyed) {
                    carousel.destroy(true, true)
                    swiperCarousels.splice(index, 1)
                }
            })
        } else if (swiperCarousels.length < featuredGridCarousels.length)  {
            featuredGridCarousels.forEach(carousel => initSwiper(carousel))
        }
    })

    if (!window.matchMedia('(min-width: 768px)').matches) {
        featuredGridCarousels.forEach(carousel => initSwiper(carousel))
    } 
}
